export default __webpack_public_path__ + "3b3bc4b22b78b3b0c55466fe30d66a8c.png";